import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import DashboardLeft from "../assets/images/DashboardLeft.png";
import DashboardRight from "../assets/images/DashboardRight.png";
import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";
import { useSelector } from "react-redux";

// Register necessary elements and plugins
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

const MainContent = () => {
  const today = new Date().toISOString().split("T")[0];
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const { userDetails } = useSelector((state) => state.auth);

  console.log(dashboardData.registration);

  const GetSroData = async () => {
    if (!fromDate || !toDate) return; // Prevent API call if dates are not set
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/DashBoard/sr_dashboard/${userDetails.dcode}/${userDetails.srocode}/${fromDate}/${toDate}`
      );
      setDashboardData(response.data.dashboardData);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetSroData();
  }, [fromDate, toDate]);
  const data = {
    labels: ["Registry", "Regularized", "Commission"],
    datasets: [
      {
        label: "Category Distribution",
        data: [
          dashboardData.registration,
          dashboardData.regularized,
          dashboardData.commission,
        ],

        backgroundColor: [
          "#3498db", // Blue
          "#f1c40f", // Yellow
          "#95a5a6", // Gray
        ],
        borderColor: "#fff", // White borders
        borderWidth: 2, // Thicker border for a cleaner look
        hoverOffset: 10, // Slightly offsets the segment on hover
        cutout: "70%", // Makes the pie chart look like a donut
        rotation: -90, // Starts drawing from the top
        circumference: 180, // Draws only 180° (half-circle)
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false, // Hide the legend if you want to match the PNG style
      },
      tooltip: {
        // callbacks: {
        //     label: function (context: 'any') {
        //         const label = context.label || '';
        //         const value = context.raw ;
        //         return ${label}: ${value};
        //     },
        // },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="relative bg-gray-100 p-6 w-full">
      {/* Burger Menu */}

      {/* Main Content */}
      <div className="grid grid-cols-12 gap-4">
        {/* First Section */}
        <div className="col-span-12 lg:col-span-8 grid grid-rows-2 gap-4">
          {/* First Panel */}
          <div
            style={{
              backgroundImage: "linear-gradient(to right, #3A8EF4, #0B54AB)",
              position: "relative",
              width: "100%",
              maxWidth: "1920px",
            }}
            className="shadow-lg rounded-xl p-6 flex flex-col justify-between"
          >
            {/* Left Bottom Image */}
            <img
              src={DashboardLeft}
              alt="Left Bottom"
              className="absolute bottom-0 left-0 h-full w-auto object-cover"
            />
            {/* Right Side Image */}
            <img
              src={DashboardRight}
              alt="Right Side"
              className="absolute right-0 top-0 h-full w-auto object-cover"
            />
            {/* Center Text */}
            <div className="flex flex-col items-center justify-center flex-grow">
              <h2 className="text-md text-white font-bold">
                Here Is Happening In Your SubRegistrar
              </h2>
              <h2 className="text-sm text-white font-bold mb-2">
                Office Last Month
              </h2>
            </div>
            {/* Statistics */}
            <div className="flex justify-center gap-4 mt-8">
              <div className="flex items-center justify-center mb-2">
                <p className="text-xl" style={{ color: "#FFDC15" }}>
                  {dashboardData.registration}
                </p>
                <p className="text-sm ml-2" style={{ color: "#FFDC15" }}>
                  Registry
                </p>
              </div>
              <div className="flex items-center justify-center mb-2">
                <p className="text-xl" style={{ color: "#FFDC15" }}>
                  {dashboardData.totalRevenue}
                </p>
                <p className="text-sm ml-2" style={{ color: "#FFDC15" }}>
                  Total Revenue
                </p>
              </div>
            </div>
            <div className="flex justify-center mt-4">
              <p className="text-xs text-white font-bold text-center mb-2">
                Report Generated From CRS, Core Registration System
              </p>
            </div>
          </div>
          {/* Second Panel */}
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-xl font-bold">Analyse Your SRO</h2>
            <p style={{ color: "#6F6F6F" }} className="text-xs">
              Select From Date and To Date to check the activity
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="mt-1 block w-full p-2 border rounded-md bg-gray-200 text-gray-700"
              />
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="mt-1 block w-full p-2 border rounded-md bg-gray-200 text-gray-700"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
              <div className="text-center">
                <p className="text-3xl font-bold">
                  {" "}
                  {dashboardData.registration}
                </p>
                <p className="text-sm text-gray-600">TOTAL REGISTRATION</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold">
                  {" "}
                  {dashboardData.regularized}
                </p>
                <p className="text-sm text-gray-600">TOTAL REGULARIZED</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold"> {dashboardData.postponed}</p>
                <p className="text-sm text-gray-600">TOTAL POSTPONED</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold">
                  {" "}
                  {dashboardData.commission}
                </p>
                <p className="text-sm text-gray-600">TOTAL COMMISSION</p>
              </div>
            </div>
          </div>
        </div>

        {/* Second Section */}
        <div className="col-span-12 lg:col-span-4">
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-xl font-bold mt-2">Categories</h2>
            <div className="flex justify-center mt-2">
              <div className="w-48 max-w-xs h-44 sm:w-52 sm:h-28 mt-4">
                <Pie data={data} options={options} />
              </div>
            </div>
            <div className="space-y-1 mt-4">
              <div className="flex items-center">
                <div className="w-4 h-4 bg-blue-500 rounded-full mr-2"></div>
                <p className="text-blue-500">
                  Registry: {dashboardData.registration}
                </p>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-yellow-500 rounded-full mr-2"></div>
                <p className="text-yellow-500">
                  Regularized: {dashboardData.regularized}
                </p>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-secondary-500 rounded-full mr-2"></div>
                <p className="text-gray-500">
                  Commission: {dashboardData.commission}
                </p>
              </div>
            </div>
            <button className="bg-blue-500 text-white w-full mt-6 p-3 rounded-md">
              View Details ➔
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
